import React from "react";
import { Fighter } from "../../../model/Dto/Fighter";
import MarketDialog from "./MarketDialog";
import UpgradesAndProfilesDialog from "./UpgradesAndProfilesDialog";
import AddInjuryDialog from "./AddInjuryDialog";
import LevelUpDialog from "./LevelUpDialog";
import CommandHistoryDialog from "./CommandHistoryDialog";
import AddSkillDialog from "./AddSkillDialog";
import EditCharacteristicsDialog from "./EditCharacteristicsDialog";
import AddExperienceDialog from "./AddExperienceDialog";
import EditFighterInfoDialog from "./EditFighterInfoDialog";

interface DialogsProps {
    dialogType: FighterPageDialogType;
    fighter: Fighter;
    fetchData: () => void;
    onClose: () => void;
    currentFighterWeaponId: string | undefined;
}

export type FighterPageDialogType =
    | "none"
    | "market"
    | "upgrades-and-profiles"
    | "injury"
    | "skill"
    | "advance"
    | "command-history"
    | "edit-characteristic"
    | "experience"
    | "edit-info";

export default function Dialogs({
                                    onClose,
                                    dialogType,
                                    fighter,
                                    fetchData,
                                    currentFighterWeaponId,
                                }: DialogsProps) {
    return (
        <>
            <MarketDialog
                open={dialogType === "market"}
                onClose={onClose}
                fighterId={fighter.id}
                factionId={fighter.factionId}
                fetchData={fetchData}
                teamId={fighter.teamId}
            />
            <UpgradesAndProfilesDialog
                open={dialogType === "upgrades-and-profiles"}
                onClose={() => {
                    onClose();
                    fetchData();
                }}
                fighterWeaponId={currentFighterWeaponId}
                teamId={fighter.teamId}
                fighterId={fighter.id}
            />
            <AddInjuryDialog
                fighterId={fighter.id}
                onClose={onClose}
                fetchData={fetchData}
                open={dialogType === "injury"}
            />
            <AddSkillDialog
                fighterId={fighter.id}
                onClose={onClose}
                fetchData={fetchData}
                open={dialogType === "skill"}
            />
            <LevelUpDialog
                fighterId={fighter.id}
                onClose={onClose}
                fetchData={fetchData}
                open={dialogType === "advance"}
            />
            <CommandHistoryDialog
                fighter={fighter}
                open={dialogType === "command-history"}
                onClose={onClose}
            />
            <EditCharacteristicsDialog
                fighter={fighter}
                open={dialogType === "edit-characteristic"}
                onClose={onClose}
                fetchData={fetchData}
            />
            {/* Добавляем диалог опыта */}
            <AddExperienceDialog
                fighterId={fighter.id}
                currentXp={fighter.xp}
                canEdit={fighter.availableForEdit}
                open={dialogType === "experience"}
                onClose={onClose}
                fetchData={fetchData}
            />
            <EditFighterInfoDialog
                fighterId={fighter.id}
                currentName={fighter.name}
                currentRank={fighter.rang}
                currentStatus={fighter.status}
                open={dialogType === "edit-info"}
                onClose={onClose}
                fetchData={fetchData}
            />
        </>
    );
}